import { useParams } from "react-router-dom";

export function usePublicView() {
  const { viewPin } = useParams<{ viewPin?: string }>();
  const isPublicView = !!viewPin;

  return {
    isPublicView,
    viewPin,
  };
}
